// src/app/error.tsx
'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-8rem)] p-4 text-center">
      <Card className="w-full max-w-md bg-card/80 backdrop-blur-lg shadow-xl border border-destructive/20 text-white">
        <CardHeader className="items-center">
          <div className="p-4 bg-destructive/10 rounded-full mb-4 inline-block">
            <AlertTriangle className="h-16 w-16 text-destructive" />
          </div>
          <CardTitle className="text-3xl font-bold">Something Went Wrong</CardTitle>
          <CardDescription className="text-md text-muted-foreground mt-2">
            An unexpected error occurred. We've been notified and are looking into it.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4">
            <pre className="mt-2 w-full overflow-auto rounded-md bg-slate-900 p-4 text-xs text-slate-200 max-h-48 text-left">
                <code>
                    <strong>Error:</strong> {error.message}
                </code>
            </pre>
          <Button
            size="lg"
            onClick={
              // Attempt to recover by trying to re-render the segment
              () => reset()
            }
            className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
          >
            Try Again
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
